import api from "@/services/api";
import {
  DashboardDateRangeParams,
  DashboardDossierStatsResponse,
} from "@/interfaces/DashboardDossierStats";

export const dashboardDossierStatsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDashboardDossierStats: build.query<
      DashboardDossierStatsResponse,
      DashboardDateRangeParams
    >({
      query: (params) => ({
        url: "/admin/stats/dossiers",
        params,
      }),
      providesTags: [{ type: "DashboardStats", id: "DOSSIERS" }],
    }),
  }),
  overrideExisting: true,
});

export const { useGetDashboardDossierStatsQuery } = dashboardDossierStatsApi;
